// labelChip.js
import { FAIcon } from './icons';
import StyleSheet from 'stilr';
import React from 'react';

const styles = StyleSheet.create({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    marginTop: '0.5em',
    marginRight: '0.5em',
    borderRadius: 4,
    border: '1px solid transparent',
    whiteSpace: 'nowrap',
    lineHeight: 1.2,
    fontSize: '1em',
    boxSizing: 'border-box'
  },
  chipIcon: { lineHeight: 1, fontSize: 14, transform: 'translateY(.5px)' },

  // keep these for future, but we won't depend on them for color right now
  chipUsp: { backgroundColor: 'rgba(33,150,243,.10)', color: 'rgb(33,150,243)', border: '1px solid rgb(33,150,243)' },
  chipReq: { backgroundColor: 'rgba(255,196,20,.51)', color: 'rgb(136,96,0)', border: '1px solid rgb(167,132,0)' }
});

const USP_STYLE = {
  backgroundColor: 'rgba(33,150,243,.10)',
  color: 'rgb(33,150,243)',
  border: '1px solid rgb(33,150,243)'
};
const REQ_STYLE = {
  backgroundColor: 'rgba(255,196,20,.51)',
  color: 'rgb(136,96,0)',
  border: '1px solid rgb(167,132,0)'
};

const Chip = ({ kind = 'usp', icon, children, style, ...rest }) => {
  const kindStyle = kind === 'req' ? REQ_STYLE : USP_STYLE;

  return (
    <span
      className={[styles.chip, kind === 'usp' ? styles.chipUsp : styles.chipReq].join(' ')}
      style={{
        // base visual layout
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        borderRadius: 4,
        padding: '4px 10px',
        // the actual colors/border come inline so they always apply
        ...kindStyle,
        // allow caller overrides
        ...style,
        marginRight: '.5em',
        marginTop: '.5em'
      }}
      {...rest}
    >
      <span className={styles.chipIcon}>{FAIcon(icon)}</span>
      <span>{children}</span>
    </span>
  );
};

export default Chip;
